import type { MeetingItem } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

const TYPEOPTIONS = [
  { text: 'Event', value: 1 },
  { text: 'Meeting', value: 2 },
];
const STATUSOPTIONS = [
  { text: 'Cancelled', value: 2 },
  { text: 'Done', value: 3 },
  { text: 'Planned', value: 4 },
  { text: 'To be scheduled', value: 1 },
];

const DEFAULT_MEETINGS: MeetingItem = {
  id: 0,
  status: 1,
  name: '',
  start_date: '',
  end_date: '',
  date_time: '',
  source: 2,
};

const DEFAULT_MEETINGS_NEW: MeetingItem[] = [
  {
    id: 0,
    status: 1,
    name: 'GR Materials Submission',
    start_date: '',
    end_date: '',
    date_time: '',
    source: 1,
  },
  {
    id: 0,
    status: 1,
    name: 'Feedback',
    start_date: '',
    end_date: '',
    date_time: '',
    source: 2,
  },
  {
    id: 0,
    status: 1,
    name: 'GR Decision',
    start_date: '',
    end_date: '',
    date_time: '',
    source: 2,
  },
];

export { DEFAULT_MEETINGS, DEFAULT_MEETINGS_NEW, STATUSOPTIONS, TYPEOPTIONS };
